// #genai Phase 2 ACH submit-error dialogs — pixel-matched to Figma 732:26114 ("Payment method
// already exists" desktop), 732:26388 (mobile), 269:22087 ("Something went wrong" desktop) and
// 269:22176 (mobile). Both dialogs share the same shell: 450px wide on desktop, 342px on mobile,
// padding 24, radius 4, ev-elevation--z24 shadow. Title 18/27 SemiBold #1B202C, body 16/24 #1B202C.
// Only the action row shape differs (single Ok vs Ok + "Return to Payment Methods" link).
import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  dialog: {
    width: '450px',
    maxWidth: 'calc(100% - 32px)',
    margin: 0,
    padding: '24px',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 11px 15px 0px rgba(0,0,0,0.2), 0px 9px 46px 0px rgba(0,0,0,0.12), 0px 24px 38px 0px rgba(0,0,0,0.14)',
    '@media (max-width: 639px)': {
      width: '342px',
      maxWidth: 'calc(100% - 48px)',
    },
  },

  title: {
    padding: 0,
    fontFamily: 'Noto Sans',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
    color: '#1B202C',
  },

  content: {
    padding: 0,
    marginTop: '24px',
  },

  message: {
    margin: 0,
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#1B202C',
  },

  // #genai Inline "contact customer support" link inside the message body. Underlined per Figma
  // 269:22087 render (charcoal on default so it blends with the body copy, only underline signals
  // it's tappable). Uses the app palette #4D5365 (charcoal-800).
  supportLink: {
    color: '#4D5365',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': { color: '#1B202C' },
  },

  actions: {
    padding: 0,
    marginTop: '24px',
    gap: '8px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    // #genai Mobile (Figma 732:26388 / 269:22176): stack the actions full-width with the primary
    // "Ok" button on TOP. JSX order is Return→Ok on the exists dialog and Ok alone on the generic
    // one, so column-reverse promotes Ok above the Return link without changing the DOM order
    // (which keeps the tab order predictable — the confirm action is the last focusable element).
    '@media (max-width: 639px)': {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
      gap: '16px',
    },
  },

  // #genai "Return to Payment Methods (Billing)" — text-only link button, no border/background.
  // On desktop it sits inline with the Ok button, right-aligned. On mobile per Figma 732:26388 it
  // drops below the full-width Ok button.
  returnLinkButton: {
    height: '44px',
    padding: '10px 16px',
    borderRadius: '4px',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.32px',
    textTransform: 'none',
    backgroundColor: 'transparent',
    color: '#007CAD',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0,124,173,0.06)',
      boxShadow: 'none',
    },
    '@media (max-width: 639px)': {
      width: '100%',
      marginLeft: 0,
    },
  },

  // #genai Primary "Ok" — small filled button, hugs its content width on desktop; full-width on mobile.
  okButton: {
    height: '44px',
    padding: '10px 16px',
    borderRadius: '4px',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.32px',
    textTransform: 'none',
    backgroundColor: '#007CAD',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#005A8D',
    },
    '@media (max-width: 639px)': {
      width: '100%',
      marginLeft: 0,
    },
  },
}));
